import styled from '@emotion/styled'
import { font, colors, radius, spacing } from '@mobi/component-library/Theme/Common'
import { gapY } from '@mobi/component-library/Utils/gap'

export const BetLimitLegal = styled.div({
  borderRadius: radius.lgx2,
  backgroundColor: colors.neutral[100],
  padding: spacing.sm,
  color: colors.neutral[900],
  marginTop: spacing.md,
  ...font.size.md,
})

export const ModalFooterStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  width: '100%',
})

export const BetLimitFormStyled = styled.div(
  {
    display: 'grid',
  },
  gapY(spacing.sm)
)
